import { memo } from 'react';
import { VStack } from '~/components/layout/Stack';
import { useAsideAnalytics } from '~/hooks/useAsideAnalytics';
import RegistrationAside from './RegistrationAside';
import styles from './SingleRegistrationAside.module.scss';
import {
  useBookkeepingTransactionId,
  useCloseSingleRegistrationAside,
  useRecommendedReconciliationFlowId,
  useSingleRegistrationAsideState,
  useTransactionIds,
} from './SingleRegistrationAsideState';
import BookkeepingTransactionForm from '../transactions/BookkeepingTransactionForm';
import BookkeepingTransactionFormHeader from '../transactions/BookkeepingTransactionFormHeader';

const SingleRegistrationAside: React.FC = memo(() => {
  const closeAside = useCloseSingleRegistrationAside();
  const asideState = useSingleRegistrationAsideState();
  const transactionIds = useTransactionIds();
  const bookkeepingTransactionId = useBookkeepingTransactionId();
  const recommendedReconciliationFlowId = useRecommendedReconciliationFlowId();

  useAsideAnalytics({ asideState });

  return (
    <RegistrationAside asideState={asideState} closeAside={closeAside}>
      <VStack className={styles.content}>
        <BookkeepingTransactionFormHeader />
        <div className={styles.form}>
          <BookkeepingTransactionForm
            transactionIds={transactionIds}
            bookkeepingTransactionId={bookkeepingTransactionId}
            recommendedReconciliationFlowId={recommendedReconciliationFlowId}
            onSuccess={closeAside}
            onClose={closeAside}
          />
        </div>
      </VStack>
    </RegistrationAside>
  );
});

export default SingleRegistrationAside;
